import { render, staticRenderFns } from "./DatosInscripcionExamen.vue?vue&type=template&id=2bc73c24&"
import script from "./DatosInscripcionExamen.vue?vue&type=script&lang=js&"
export * from "./DatosInscripcionExamen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports